import { inject } from "vue";
import { useField } from "vee-validate";
import type { ExtractPropTypes, PropType } from "vue";

import type { DsInputTypes } from "../../types";

export const DsPropsBase = {
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    default: "ds-input-base",
    required: true,
  },
  modelValue: {
    type: [String, Number, Boolean, Array],
    required: true,
  },
  type: {
    type: String as PropType<DsInputTypes>,
    default: "text",
  },
  label: {
    type: String,
    required: false,
  },
  autocomplete: {
    type: String,
    default: "",
  },
  autofocus: {
    type: Boolean,
    default: false,
  },
  populating: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  dataTestid: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
};

export const DsEmitBase = ["update:modelValue"];

export type DsPropsBaseType = ExtractPropTypes<typeof DsPropsBase>;
export function useDsInputBase<T = string | number | boolean | []>(
  props: DsPropsBaseType,
  syncVModel = true
) {
  const populatingForm = inject("populatingForm") as boolean;

  const { value, errorMessage, handleReset } = useField(
    () => props.name,
    undefined,
    {
      initialValue: props.modelValue as T,
      syncVModel: syncVModel,
      keepValueOnUnmount: true,
    }
  );

  return {
    model: value,
    error: errorMessage,
    populatingForm,
    reset: handleReset,
  };
}
